<template>
  <div>
    <GrapejsWebsiteBuilder />
  </div>
</template>

<script>
import { BCard, BCardText, BButton, BRow, BCol } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";

import GrapejsWebsiteBuilder from "./GrapejsWebsiteBuilder.vue";

export default {
  components: {
    BCard,
    BCardText,
    BButton,
    BRow,
    BCol,
    GrapejsWebsiteBuilder,
  },
  directives: {
    Ripple,
  },
  data() {
    return {};
  },
};
</script>
